<template>
    <svg viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25 25L45 45M25 45L45 25M68 35C68 53.2254 53.2254 68 35 68C16.7746 68 2 53.2254 2 35C2 16.7746 16.7746 2 35 2C53.2254 2 68 16.7746 68 35Z" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
    export default {
        name: "FailIcon"
    }
</script>

<style scoped>

</style>